import SectionTitle from '@/components/base/SectionTitle';
import FaqAccordion from '@/components/feature/FaqAccordion';
import ContactSection from '@/components/feature/ContactSection';
import HeroSection from '@/pages/home/components/HeroSection';
import StepsSection from '@/pages/home/components/StepsSection';
import HotTopicsSection from '@/pages/home/components/HotTopicsSection';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import PrinciplesSection from '@/pages/home/components/PrinciplesSection';
import TestimonialsSection from '@/pages/home/components/TestimonialsSection';
import { usePageSeo } from '@/hooks/usePageSeo';
import { faqItems } from '@/mocks/faq';
import { topics } from '@/mocks/topics';

const homeStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '网络爆料求证专区｜瓜田求证社',
    description:
      '聚焦网络爆料真假、求证、辟谣与辟皮，用来源比对、时间线与证据清单帮你厘清事件脉络。',
    url: 'https://lebangyouxuan.cn/',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '热门求证话题',
    itemListElement: topics.slice(0, 6).map((topic, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: topic.title,
      url: `https://lebangyouxuan.cn/topic/${topic.id}`,
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  },
];

export default function Home() {
  usePageSeo({
    title: '网络爆料求证专区 | 瓜田求证社 · 理性吃瓜辨真伪',
    description:
      '瓜田求证社是聚焦网络爆料真假、求证、辟谣与扒皮的内容社区，用来源比对、时间线与证据清单帮你厘清事件脉络，辨别信息真伪，理性参与热门爆料话题讨论。',
    keywords: '网络爆料,网络爆料真假,网络爆料求证,网络爆料辟谣,网络爆料分析',
    path: '/',
    structuredData: homeStructuredData,
  });

  return (
    <>
      <HeroSection />
      <StepsSection />
      <HotTopicsSection />
      <CategoriesSection />
      <PrinciplesSection />
      <TestimonialsSection />

      <section id="faq" className="w-full border-b border-background-200 bg-background-100/50 py-14 md:py-20">
        <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
          <SectionTitle
            eyebrow="Common Questions"
            title="关于求证，你可能想问"
            desc="我们把读者最常问的几个问题整理在这里。如果还有疑问，欢迎通过下方的线索入口联系我们。"
            align="center"
          />
          <div className="mt-10">
            <FaqAccordion items={faqItems} />
          </div>
        </div>
      </section>

      <ContactSection />
    </>
  );
}